export const LIMIT = 10;
export const UPLOAD_CONST = "";
// export const URI = "https://sehari-api.webgrowsolutions.com";
export const URI = "http://localhost:5057";
